import { Source } from 'app/models/source.enum';

export class UsefulLink {
  id: string;
  parentId: string;
  createdTime:number;
  displayName: string;
  name: string;
  link: string;
  source: Source;
  priority?: boolean;

  constructor(
    id: string,
    parentId: string,
    displayName: string,
    name: string,
    link: string,
    source: Source,
    priority?: boolean) {

    this.id = id;
    this.parentId = parentId;
    this.displayName = displayName;
    this.name = name;
    this.link = link;
    this.source = source;
    this.priority = priority;
  }
}
